import { render } from "./TemplateModal.vue?vue&type=template&id=4c4300cf"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"

import "./TemplateModal.vue?vue&type=style&index=0&id=4c4300cf&lang=scss"
script.render = render

export default script